import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.fixed.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import { onSSR } from "../../plugins/Platform.js";
import QResizeObserver from "../resize-observer/QResizeObserver.js";
import ListenersMixin from "../../mixins/listeners.js";
import { mergeSlot } from "../../utils/slot.js";
import { stop } from "../../utils/event.js";
import cache from "../../utils/cache.js";
export default Vue.extend({
  name: 'QFooter',
  mixins: [ListenersMixin],
  inject: {
    layout: {
      default: function _default() {
        console.error('QFooter needs to be child of QLayout');
      }
    }
  },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    reveal: Boolean,
    bordered: Boolean,
    elevated: Boolean,
    heightHint: {
      type: [String, Number],
      default: 50
    }
  },
  data: function data() {
    return {
      size: parseInt(this.heightHint, 10),
      revealed: true,
      windowHeight: onSSR || this.layout.container ? 0 : window.innerHeight
    };
  },
  watch: {
    value: function value(val) {
      this.__update('space', val);

      this.__updateLocal('revealed', true);

      this.layout.__animate();
    },
    offset: function offset(val) {
      this.__update('offset', val);
    },
    reveal: function reveal(val) {
      val === false && this.__updateLocal('revealed', this.value);
    },
    revealed: function revealed(val) {
      this.layout.__animate();

      this.$emit('reveal', val);
    },
    'layout.scroll': function layoutScroll() {
      this.__updateRevealed();
    },
    'layout.height': function layoutHeight() {
      this.__updateRevealed();
    },
    size: function size() {
      this.__updateRevealed();
    },
    '$q.screen.height': function $qScreenHeight(val) {
      this.layout.container !== true && this.__updateLocal('windowHeight', val);
    }
  },
  computed: {
    fixed: function fixed() {
      return this.reveal === true || this.layout.view.indexOf('F') > -1 || this.$q.platform.is.ios && this.layout.container === true;
    },
    containerHeight: function containerHeight() {
      return this.layout.container === true ? this.layout.containerHeight : this.windowHeight;
    },
    offset: function offset() {
      if (this.value !== true) {
        return 0;
      }

      if (this.fixed === true) {
        return this.revealed === true ? this.size : 0;
      }

      var offset = this.layout.scroll.position + this.containerHeight + this.size - this.layout.height;
      return offset > 0 ? offset : 0;
    },
    hidden: function hidden() {
      return this.value !== true || this.fixed === true && this.revealed !== true;
    },
    revealOnFocus: function revealOnFocus() {
      return this.value === true && this.hidden === true && this.reveal === true;
    },
    classes: function classes() {
      return (this.fixed === true ? 'fixed' : 'absolute') + '-bottom' + (this.bordered === true ? ' q-footer--bordered' : '') + (this.hidden === true ? ' q-footer--hidden' : '') + (this.value !== true ? ' q-layout--prevent-focus' : '') + (this.value !== true && this.fixed !== true ? ' hidden' : '');
    },
    style: function style() {
      var view = this.layout.rows.bottom,
          css = {};

      if (view[0] === 'l' && this.layout.left.space === true) {
        css[this.$q.lang.rtl === true ? 'right' : 'left'] = "".concat(this.layout.left.size, "px");
      }

      if (view[2] === 'r' && this.layout.right.space === true) {
        css[this.$q.lang.rtl === true ? 'left' : 'right'] = "".concat(this.layout.right.size, "px");
      }

      return css;
    },
    onEvents: function onEvents() {
      return _objectSpread(_objectSpread({}, this.qListeners), {}, {
        focusin: this.__onFocusin,
        input: stop
      });
    }
  },
  render: function render(h) {
    var child = mergeSlot([h(QResizeObserver, {
      props: {
        debounce: 0
      },
      on: cache(this, 'resize', {
        resize: this.__onResize
      })
    })], this, 'default');
    this.elevated === true && child.push(h('div', {
      staticClass: 'q-layout__shadow absolute-full overflow-hidden no-pointer-events'
    }));
    return h('footer', {
      staticClass: 'q-footer q-layout__section--marginal',
      class: this.classes,
      style: this.style,
      on: this.onEvents
    }, child);
  },
  created: function created() {
    this.layout.instances.footer = this;
    this.value === true && this.__update('size', this.size);

    this.__update('space', this.value);

    this.__update('offset', this.offset);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.layout.instances.footer === this) {
      this.layout.instances.footer = void 0;

      this.__update('size', 0);

      this.__update('offset', 0);

      this.__update('space', false);
    }
  },
  methods: {
    __onResize: function __onResize(_ref) {
      var height = _ref.height;

      this.__updateLocal('size', height);

      this.__update('size', height);
    },
    __update: function __update(prop, val) {
      if (this.layout.footer[prop] !== val) {
        this.layout.footer[prop] = val;
      }
    },
    __updateLocal: function __updateLocal(prop, val) {
      if (this[prop] !== val) {
        this[prop] = val;
      }
    },
    __updateRevealed: function __updateRevealed() {
      if (this.reveal !== true) {
        return;
      }

      var _this$layout$scroll = this.layout.scroll,
          direction = _this$layout$scroll.direction,
          position = _this$layout$scroll.position,
          inflexionPosition = _this$layout$scroll.inflexionPosition;

      this.__updateLocal('revealed', direction === 'up' || position - inflexionPosition < 100 || this.layout.height - this.containerHeight - position - this.size < 300);
    },
    __onFocusin: function __onFocusin(evt) {
      if (this.revealOnFocus === true) {
        this.__updateLocal('revealed', true);
      }

      this.$emit('focusin', evt);
    }
  }
});